import React, { useContext } from "react"
import { ScrollView, StyleSheet, View } from "react-native"
import { theme } from "../theme/theme"
import { DimensionsContext } from "../utils/mobileUtils"
import { ErrorScreen } from "./ErrorScreen"
import { LoadingScreen } from "./LoadingScreen"

export const ScreenSkeleton = ({
    errorScreenProps,
    isLoading,
    loadingMessage,
    children,
    bgColor,
    withCenterContent,
    bottomContent,
    containerStyle,
    contentContainerStyle,
    withScroll = true,
    contentWrapperStyle = {},
    scrollViewRef,
}) => {
    const dimensions = useContext(DimensionsContext)

    if (errorScreenProps?.error && !isLoading) {
        return <ErrorScreen {...errorScreenProps} />
    }

    if (isLoading) {
        return <LoadingScreen bgColor={bgColor} message={loadingMessage} />
    }

    if (withCenterContent) {
        return (
            <View style={[styles.container, containerStyle]}>
                <View
                    style={[
                        styles.content,
                        { width: dimensions.width },
                        contentWrapperStyle,
                    ]}
                >
                    {withScroll ? (
                        <ScrollView
                            ref={scrollViewRef}
                            showsVerticalScrollIndicator={false}
                            contentContainerStyle={contentContainerStyle}
                        >
                            {children}
                        </ScrollView>
                    ) : (
                        children
                    )}
                    {bottomContent}
                </View>
            </View>
        )
    }

    return children
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center",
        backgroundColor: theme.colors.whiteAlmost,
    },
    content: {
        flex: 1,
        paddingHorizontal: 10,
        gap: 20,
    },
})
